import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/home/HeroSection';
import NeuBeiDartCloudSection from '../components/home/NeuBeiDartCloudSection';
import ForumTopicsSection from '../components/home/ForumTopicsSection';
import AppDownloadCta from '../components/home/AppDownloadCta';
import NewsSection from '../components/NewsSection';

/**
 * Startseite – nachgebaut nach dem Aufbau der Flutter-App:
 * Hero mit Suche & "Spiele heute" → Neu bei DartCloud → Neue Forum-Beiträge
 * → News → App-Download.
 */
const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-zinc-950">
      <Helmet>
        <title>DartCloud - Deine Darts-Plattform</title>
        <meta
          name="description"
          content="Finde Turniere, Vereine, Spielstätten und Dart-Shops in deiner Nähe. Live-Scores, News und die Darts-Community auf DartCloud."
        />
      </Helmet>

      <HeroSection />
      <NeuBeiDartCloudSection />
      <ForumTopicsSection />
      <NewsSection />
      <AppDownloadCta />
    </div>
  );
};

export default HomePage;
